// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ext9","title":"styles_title__cB0mr"};